export const RESIZE_MESSAGE_TYPE = 'wtta-quickscan:resize'

export interface ResizeMessage {
  type: typeof RESIZE_MESSAGE_TYPE
  height: number
  widgetId: string
}

export interface AutoResizeOptions {
  widgetId: string
  target: HTMLElement
  postMessage?: (message: ResizeMessage) => void
}

export function startAutoResize(options: AutoResizeOptions): () => void {
  const { widgetId, target } = options
  const post = options.postMessage ?? defaultPostMessage

  let lastHeight = -1

  const sendIfChanged = () => {
    const height = Math.ceil(target.getBoundingClientRect().height)
    if (height !== lastHeight) {
      lastHeight = height
      post({ type: RESIZE_MESSAGE_TYPE, height, widgetId })
    }
  }

  const observer = typeof ResizeObserver !== 'undefined'
    ? new ResizeObserver(() => sendIfChanged())
    : null

  observer?.observe(target)
  sendIfChanged()

  return () => {
    observer?.disconnect()
  }
}

function defaultPostMessage(message: ResizeMessage): void {
  if (typeof window === 'undefined') return
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(message, '*')
  }
  window.dispatchEvent(new CustomEvent(RESIZE_MESSAGE_TYPE, { detail: message }))
}
